import React from 'react'
import Header from '../components/Header'
import locale from '../locale'
import Hero from '../components/Hero'
import en from '../locale/en'
import cn from '../locale/cn'
import InfoBlockGrid from '../components/InfoBlockGrid'
import HorizontalInfoBlock from '../components/HorizontalInfoBlock'
import SectionHeader from '../components/SectionHeader'
import SubsectionHeader from '../components/SubsectionHeader'
import CardGrid from '../components/CardGrid'
import LinkBox from '../components/LinkBox'
import Layout from '../components/Layout'
import Footer from '../components/Footer'
import { graphql } from 'gatsby'
import './page.css'

let data = { en, cn };
let localizedData = () => data[locale.getLocale()];
let header_data = localizedData().header;
let europe_tour_data = localizedData().europe_tour;
let isShort = true;

class EuropeTourPage extends React.Component {

    constructor(props) {
      super(props);

      this.state = {
        isShiftedLeft: false,
      }

      this.shiftLeft = this.shiftLeft.bind(this);
      this.shiftRight = this.shiftRight.bind(this);
    }

    shiftLeft() {
      this.setState({isShiftedLeft: true});
    }

    shiftRight() {
      this.setState({isShiftedLeft: false});
    }

    render() {
      return (
        <div className={"page " + (this.state.isShiftedLeft ? "left-shift" : "neutral-shift")}>
        <Layout>
        <Header
          onBMOpen={this.shiftLeft}
          onBMClose={this.shiftRight}
          fluid={this.props.data.logoImage.childImageSharp.fluid}
          data={header_data}>
        </Header>

        <Hero
          isShort = {isShort}
          fluid = {this.props.data.heroImage.childImageSharp.fluid}
          data={europe_tour_data.hero}>
        </Hero>

        <div className="cropped-width">

          <SectionHeader data={europe_tour_data.header}></SectionHeader>

          <InfoBlockGrid
            data={europe_tour_data.artists}
            nCellsPerRow={2}
            nCellsPerRowMobile={1}
            images={this.props.data.artistImages.edges}></InfoBlockGrid>
          <br></br><br></br><br></br><br></br>
          <InfoBlockGrid
            data={europe_tour_data.tour.venues}
            nCellsPerRow={2}
            nCellsPerRowMobile={1}
            images={this.props.data.venuesImages.edges}></InfoBlockGrid>
          <br></br><br></br><br></br><br></br>

            <hr style={{border: '0.5px solid #DEDEDE'}} ></hr>

            <SectionHeader data={europe_tour_data.residency.header}></SectionHeader>

            <HorizontalInfoBlock
              data={europe_tour_data.residency.info}
              fluid={this.props.data.residencyImage.childImageSharp.fluid}></HorizontalInfoBlock>

            <SubsectionHeader
                data={europe_tour_data.residency.teaching_artists.header}></SubsectionHeader>

            <CardGrid
                nCellsPerRow = {4}
                nCellsPerRowMobile = {1}
                data = {europe_tour_data.residency.teaching_artists.artists}
                images = {this.props.data.teachingArtistImages.edges}
              ></CardGrid>
            <br></br><br></br><br></br><br></br>

        </div>

        <Footer></Footer>

        </Layout>


      </div>
    )
  }
}

export default EuropeTourPage;

export const pageQuery = graphql`
  query EuropeTourQuery {
    logoImage: file(relativePath: { eq: "logo_white.png" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    },
    heroImage: file(relativePath: { eq: "2019-europe-tour/hero.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 2000) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    },
    artistImages: allFile(filter: { relativeDirectory: { eq: "2019-europe-tour/artists" } }) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 400) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    },
    residencyImage: file(relativePath: { eq: "2019-europe-tour/residency.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 400) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    },
    venuesImages: allFile(filter: { relativeDirectory: { eq: "2019-europe-tour/venues" } }) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 600) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    },
    teachingArtistImages: allFile(filter: { relativeDirectory: { eq: "2019-europe-tour/teaching_artists" } }) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 600) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    },
  }
`;
